// extracted by mini-css-extract-plugin
module.exports = {"box":"box_oFey7","boxInfo":"boxInfo_qVlTn","boxRole":"boxRole_Wagt4","arrow":"arrow_5CoK9","item":"item_-e4gZ"};